import React, { createContext, useState } from "react";

export const AppContext = createContext();
export const AppContextProvider = ({ children }) => {
  const [values, setValues] = useState({
    tipoSolicitacao: "op1",
    justify: "",
    nome: "",
    nomeTerceiros: "",
    cpf: "",
    cpfTerceiros: "",
    email: "",
    nascimento: "",
    nascimentoTerceiros: "",
    celular: "",
    solicitacaoTerceiros: "filhos",
    isVerified: false,
  });

  const updateValuesHandler = (value, name) => {
    setValues({ ...values, [name]: value });
  };

  return (
    <AppContext.Provider value={{ values, updateValuesHandler }}>
      {children}
    </AppContext.Provider>
  );
};
